<script setup lang="ts">
  /**
   * Plan card group — 03-components/20d-plan-card · OSCloud DS 1.1.166
   *
   * The horizontal grid BfPlanCard options are compared in: cards stretch to one height and
   * fold to fewer columns as the row narrows. The group is the field's control slot — the
   * consumer wraps it in the fieldset that names the choice.
   */
  withDefaults(
    defineProps<{
      /** For a group on a tinted ground: the chosen card keeps its doubled edge but drops its shadow. */
      flat?: boolean
      /** The narrowest a card may get before the row folds (any CSS length). Default 230px. */
      minWidth?: string
    }>(),
    { flat: false, minWidth: undefined },
  )
</script>

<template>
  <div
    class="plan-card-group"
    :class="{ 'plan-card-group--flat': flat }"
    :style="minWidth ? { '--plan-card-min-width': minWidth } : undefined"
  >
    <slot />
  </div>
</template>

<style scoped lang="scss">
  /* --plan-card-min-width is the only knob, set on the group, never on a card. */
  .plan-card-group {
    --plan-card-min-width: 230px;

    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(var(--plan-card-min-width), 100%), 1fr));
    gap: var(--bf-sp-3);
    align-items: stretch;
  }

  /* A flagged card in the first row needs headroom for the badge. */
  .plan-card-group:has(.plan-card__flag) {
    padding-top: 11px;
  }
</style>
